<template>

	<div class="tabWrapper homeUserInfo">
		<div class="main">
<!--			photo-->
			<div class="itemInformation photo">

				<div class="photoWrap">
					<img v-if="logoMod.url && isErrorFile || isUpdateAvatar" :src="logoMod.url" :alt="modName" @error="onError">
					<svg-sprite v-else width="120" height="120" icon-id="user"></svg-sprite>
					<div v-if="getIconId" class="iconCompany">
						<svg-sprite :icon-id="getIconId" width="20px" height="20px"></svg-sprite>
					</div>
					<div v-if="logoMod.url && isErrorFile || isUpdateAvatar"
							class="photoBtn photoZoom" @click="onPhotoZoom(logoMod.url)">
						<tool-tip
								text="Zoom Photo"
								content-class="top"
								custom-class="question"
								:position="{ top: 'top' }"
						>
							<svg-sprite icon-id="icon-zoom-in" width="20" height="20"></svg-sprite>
						</tool-tip>
					</div>

<!--					<div class="photoBtn photoEdit" @click="toggleShow">-->
<!--						<tool-tip-->
<!--								text="Set new avatar"-->
<!--								content-class="right"-->
<!--								custom-class="question"-->
<!--								:position="{ right: 'right' }"-->
<!--						>-->
<!--							<svg-sprite icon-id="edit" width="20" height="20"></svg-sprite>-->
<!--						</tool-tip>-->
<!--					</div>-->
				</div>
				<custom-btn
						v-if="isUpdateAvatar"
						text="Update avatar"
						custom-class="warning extended"
						margin="0"
						@updateEvent="getUpdateAvatar"
				></custom-btn>

				<item-info-row
						icon-id="crown"
						:is-item-text="false"
						:is-item-dashed="false"
						:value="modName"
						is-big-value
						is-flex-start
						custom-class="userName"
				></item-info-row>

			</div>

<!--			userGeneralInfoWrapper-->
			<div class="itemInformation userGeneralInfoWrapper">
				<div class="section">

					<div class="rowWrap">
						<item-info-row
								icon-id="crown"
								:is-item-text="false"
								:is-item-dashed="false"
								:value="modName"
								is-big-value
								is-flex-start
								custom-class="userName"
						></item-info-row>
					</div>

					<div class="rowWrap">
						<item-info-row
								icon-id="mapPin"
								text="Location:"
								:value="getLocation()"
						></item-info-row>
					</div>
					<div class="rowWrap">
						<item-info-row
								icon-id="department"
								text="Department:"
								:value="department"
						></item-info-row>
					</div>
					<div class="rowWrap">
						<item-info-row
								icon-id="directory"
								text="Position:"
								:value="position"
						></item-info-row>
						<tool-tip-question
								v-if="!position"
								text="The start date of work is not specified."
						></tool-tip-question>
					</div>
					<div class="rowWrap">
						<item-info-row
								icon-id="partyHorn"
								text="Start working date:"
								:value="start_working_date"
								:is-item-value="!!start_working_date"
						></item-info-row>
						<tool-tip-question
								v-if="!start_working_date"
								text="The start date of work is not specified."
						></tool-tip-question>
					</div>
					<div class="rowWrap">
						<item-info-row
								icon-id="bat"
								text="Worked:"
								:value="time_worked"
						></item-info-row>

						<tool-tip-question
								v-if="!start_working_date"
								text="The start date of work is not specified."
						></tool-tip-question>
					</div>
					<div class="rowWrap">
						<item-info-row
								icon-id="MoneyReceive"
								text="Balance:"
								:value="balance"
								is-value-first-icon
								value-first-icon="icon_dollars"
								value-first-icon-width="8"
								value-first-icon-height="16"
								:is-item-value="!!balance"
						></item-info-row>
						<tool-tip-question
								v-if="!balance"
								text="There is no balance"
						></tool-tip-question>
					</div>

				</div>
			</div>
<!--			timeWrapper-->
			<div class="itemInformation timeWrapper">
				<div class="section">
					<item-info-row
							icon-id="statistics-chart-graph"
							:is-item-text="false"
							:is-item-dashed="false"
							value="Work time"
							is-big-value
							is-flex-start
					></item-info-row>

					<div class="timeInfoWrap">
						<tool-tip
								text="Need to work time"
								content-class="top"
								custom-class="question"
								:position="{ top: 'top' }"
						>
							<item-info-row
									icon-id="TimeAdd"
									:is-item-text="false"
									:is-item-dashed="false"
									:value="timeLeft"
									is-flex-start
									custom-class="iconColorYellow"

							></item-info-row>
						</tool-tip>

						<tool-tip
								text="Worked time"
								content-class="top"
								custom-class="question"
								:position="{ top: 'top' }"
						>
							<item-info-row
									icon-id="TimeCheck"
									:is-item-text="false"
									:is-item-dashed="false"
									:value="workTimeMod"
									is-flex-start
							></item-info-row>
						</tool-tip>

						<tool-tip
								text="Total time"
								content-class="top"
								custom-class="question"
								:position="{ top: 'top' }"
						>
							<item-info-row
									icon-id="TimeFast"
									:is-item-text="false"
									:is-item-dashed="false"
									:value="allTimeMod"
									is-flex-start
									custom-class="iconColorGrey"
							></item-info-row>
						</tool-tip>
					</div>

					<div class="timeWorkWrap">
						<div class="lineWrap">
							<div class="timeLine allTime"></div>
							<div class="timeLine workTime" :style="{ width: getwWidthPercentage + '%' }"></div>

							<tool-tip
									:text="getwWidthPercentageText"
									content-class="bottom"
									custom-class="question"
									:position="{ bottom: 'bottom' }"
							>
								<div class="timeLine filter">
									<div class="item"></div>
									<div class="item"></div>
									<div class="item"></div>
									<div class="item"></div>
								</div>
							</tool-tip>
						</div>
					</div>
					<item-info-row
							v-if="overtimeData"
							icon-id="TimeForward"
							text="Overtime:"
							:value="overtimeData"
							is-value-icon
							value-icon="icon-hour"
							value-icon-width="8px"
							value-icon-height="16px"
					></item-info-row>
				</div>
			</div>
<!--			salaryWrapper-->
			<div class="itemInformation salaryWrapper">
				<div class="section">
					<item-info-row
							icon-id="dollar-sign"
							:is-item-text="false"
							:is-item-dashed="false"
							value="Salary Information"
							is-big-value
							is-flex-start
					></item-info-row>

					<div class="rowWrap" v-if="salary || salary === 0">
						<item-info-row
								icon-id="CreditCard"
								text="Salary:"
								:value="salary"
								is-value-first-icon
								value-first-icon="icon_dollars"
								value-first-icon-width="8"
								value-first-icon-height="16"
						></item-info-row>
						<div class="btnWrapper">
							<tool-tip-question
									text="Total monthly"
							></tool-tip-question>

						</div>
					</div>

					<div class="rowWrap" v-if="bonus || bonus === 0">
						<item-info-row
								icon-id="CreditCardPlus"
								text="Bonus:"
								:value="bonus"
								is-value-first-icon
								value-first-icon="icon_dollars"
								value-first-icon-width="8"
								value-first-icon-height="16"
						></item-info-row>
						<div class="btnWrapper">
							<tool-tip-question
									text="The sum of all your bonuses for this period"
							></tool-tip-question>

						</div>
					</div>

					<div class="rowWrap" v-if="charge || charge === 0">
						<item-info-row
								icon-id="CreditCardMinus"
								text="Charge:"
								:value="charge"
								is-value-first-icon
								value-first-icon="icon_dollars"
								value-first-icon-width="8"
								value-first-icon-height="16"
						></item-info-row>
						<div class="btnWrapper">
							<tool-tip-question
									text="The sum of all your fines for this period"
							></tool-tip-question>

						</div>
					</div>

					<div class="rowWrap" v-if="total || total === 0">
						<item-info-row
								icon-id="icon-total"
								text="Total:"
								:value="total"
								is-value-first-icon
								value-first-icon="icon_dollars"
								value-first-icon-width="8"
								value-first-icon-height="16"
						></item-info-row>
						<div class="btnWrapper">
							<tool-tip-question
									text="Total of all your bonuses, fines and salary for this period"
							></tool-tip-question>
						</div>
					</div>

					<div class="rowWrap" v-if="late || late === 0">
						<item-info-row
								icon-id="TriangleExclamation"
								text="Late:"
								:value="late"
								is-value-icon
								value-icon="icon-minute"
								value-icon-width="11"
								value-icon-height="16"
						></item-info-row>

						<div class="btnWrapper">
							<tool-tip-question
									text="Total number of minutes late for this period"
							></tool-tip-question>

						</div>
					</div>

					<div class="rowWrap" v-if="undetected || undetected === 0">
						<item-info-row
								icon-id="CircleQuestion"
								text="Undetected:"
								:value="undetected"
								is-value-first-icon
								value-first-icon="icon_dollars"
								value-first-icon-width="8"
								value-first-icon-height="16"
						></item-info-row>
						<div class="btnWrapper">
							<tool-tip-question
									text="Total monthly salary with Bonus and Сharge"
							></tool-tip-question>

						</div>
					</div>
				</div>
			</div>
<!--			salaryFormulaWrapper-->
			<div class="itemInformation salaryFormulaWrapper" v-if="scf">
				<div class="section">
					<item-info-row
							icon-id="icon-Formula"
							:is-item-text="false"
							:is-item-dashed="false"
							value="Salary calculation formula"
							is-big-value
							is-flex-start
					></item-info-row>
					{{ scf }}

				</div>

			</div>
<!--			workTableWrapper-->
			<div class="itemInformation workTableWrapper">
				<div class="workTableHead">
					<div class="dateListWrap">
						<field
								v-if="!isMonth"
								inputClass="dateList"
								borderRadius="4px"
								margin="0"
								@updateSelect="onSelect($event, 'dateListStart')"
								:autocompleteValue="dateListStart"
								:items="dateList"
								:isClearable="false"
								item-text="name"
								item-value="date"
								is-select
						></field>

						<field
								v-else
								margin="0"
								width="210px"
								type="text"
								placeholder="Enter month"
								@updateDate="onDate($event, 'month')"
								:dateValue="month"
								isNoTitle
								isDate
								:month-mod="monthMod"
								date-picker-type="month"
						></field>
					</div>

					<custom-btn
							:is-disabled="isDuties()"
							text="Duties"
							@updateEvent="onViewDuties"
							custom-class="duties"
							is-all-elements
							margin='0'
							:icon-attrs="{width: 18, height: 18, iconId: 'icon-ListDuties'}"
					></custom-btn>
				</div>

				<div v-if="isMonthLocal === false" class="workTableMain" :class="{ halloween: $inWindow(DATE.HALLOWEEN) }">
					<week-wrap
							v-for="(week, index) in weeks"
							:key="index"
							:weekTitle="`Week #${index + 1}`"
							@updateEventIconBtn="onEventIconBtn"
							:weeks="week"
							:allTime="allTimeMod"
							is-icon-btn
					></week-wrap>
				</div>
				<div v-else-if="isMonthLocal === true" class="workTableMainMonth" :class="{ halloween: $inWindow(DATE.HALLOWEEN) }">
					<month-wrap
							:list="userProfile_calendar"
							@updateEventIconBtn="onEventIconBtn"
							is-btn-work-time
							is-btn-sick
					/>
				</div>
				<div v-else class="workTableMain skeleton"></div>

			</div>

		</div>

		<preload v-if="isPreloader"></preload>

		<dialog-remove
				v-if="isDialogRemove"
				:titleRemove="titleRemove"
				:textRemove="textRemove"
				@updateRemove="onRemove"
				@updateCloseRemove="onCloseRemove"
		></dialog-remove>

		<my-upload
				field="img"
				@crop-success="cropSuccess"
				@crop-upload-success="cropUploadSuccess"
				@crop-upload-fail="cropUploadFail"
				@src-file-set="srcFileSet"
				v-model="show"
				langType="en"
				:width="480"
				:height="480"

				:params="params"
				:headers="headers"
				img-format="png"
				noCircle
		></my-upload>

		<preview-doc
				v-if="linkPreviewDoc"
				@clear-link="clearLinkPreviewDoc"
				:link-doc="linkPreviewDoc"
				:file-name="fileName"
		></preview-doc>

		<edit-time
			v-if="isEditTime"
			:active-item="activeItem"
			@updateClose="onCloseEditTime"
			@updateSave="onSendEditTime"
		></edit-time>

	</div>
</template>

<script>
import DialogRemove from "@/shared/DialogRemove/DialogRemove.vue";
import Preload from "@/shared/Preload/Preload.vue";
import { mapActions, mapGetters } from "vuex";
import moment from "moment/moment";
import ItemInfoRow from "@/shared/ItemInfoRow/ItemInfoRow.vue";
import { TEXT, TITLE } from "@/pages/Account/constants";
import { getAppUrl } from "@/services";
import ToolTipQuestion from "@/shared/ToolTipQuestion/ToolTipQuestion.vue";
import WeekWrap from "@/pages/Account/Tabs/WeekWrap/WeekWrap.vue";
import ToolTip from "@/shared/ToolTip/ToolTip.vue";
import myUpload from "vue-image-crop-upload/upload-2.vue";
import PreviewDoc from "@/modules/invoices/preview.vue";
import EditTime from "@/pages/UserProfile/Drawers/EditTime.vue";
import { getCalculateTimeDifference } from "@/helper/getCalculateTimeDifference";
import MonthWrap from "@/pages/Account/Tabs/MonthWrap/MonthWrap.vue";
import { getFormatYmToLongTitle, toMonthBool } from "@/helper";
import { DATE } from "@/constants/date";

export default {
	name: "UserTabHome",
	components: {
		MonthWrap,
		EditTime,
		PreviewDoc,
		myUpload,
		ToolTip,
		WeekWrap,
		ToolTipQuestion,
		ItemInfoRow,
		Preload,
		DialogRemove
	},
	props: {

	},

	computed: {
		...mapGetters([
			"userProfile_user",
			"userProfile_duties",
			"userProfile_calendar",
			"userProfile_managers",
			"userProfile_month",
			"userProfile_month_calendar",
			"userProfile_overtime",
			"userProfile_total_schedule_time",
			"userProfile_total_work_time",
			"userProfile_month_info",
		]),

		getwWidthPercentage() {
			return (this.workTime / this.allTime) * 100;
		},
		getwWidthPercentageText() {
			const percentage = ((this.workTime / this.allTime) * 100).toFixed(1);
			return `${ this.workTimeMod } hours worked (${ percentage }%)`;
		},
		getIconId() {
			if (this.company_id === 2) return "icon-altex";
			if (this.company_id === 1) return "icon-fleet";
			return null;
		},
	},

	data: () => ({
		DATE,
		isErrorFile: true,
		bonus: null,
		company_id: null,
		charge: null,
		salary: null,
		total: null,
		late: null,
		undetected: null,
		modName: null,
		isDialogRemove: false,
		titleRemove: null,
		textRemove: null,
		flagRemove: null,

		timeLeft: null,
		allTime: null,
		workTime: null,
		allTimeMod: null,
		workTimeMod: null,
		dateListStart: null,
		dateList: null,

		balance: null,
		created_at: null,
		department: null,
		department_id: null,
		dispatch_id: null,
		division_id: null,
		email: null,
		id: null,
		name: null,
		office: null,
		location: null,
		image: null,
		password: null,
		position: null,
		role: null,
		show_check_button: null,
		start_working_date: null,
		time_worked: null,
		type: null,
		scf: null,
		updated_at: null,

		overtimeData: null,

		month_calendarData: null,
		isPreloader: false,
		weeks: [],

		show: false,
		params: {
			token: "123456798",
			name: "avatar"
		},
		headers: {
			smail: "*_~"
		},
		imgDataUrl: "",

		logoMod: {},
		isUpdateAvatar: false,

		linkPreviewDoc: null,
		fileName: null,

		activeItem: null,
		isEditTime: false,
		dutiesHTML: null,

		isMonth: false,
		isMonthLocal: null,
		month: null,
		monthMod: null,

	}),
	methods: {
		...mapActions([
			"getUserProfileInfo",
			"getUserUpdateCalendar",
			"getUserСheck",
			"onEditPassword",
			"getUserEditTime",
		]),

		isDuties() {
			return this.duties && this.duties.length < 0;
		},
		onViewDuties() {
			const duties = this.dutiesHTML;
			const department = this.department;

			this.$emit("updateViewDuties", { duties, department });
		},

		onError() {
			this.isErrorFile = false;
		},
		onRemoveDialog(args) {
			const { title, text } = args;
			this.titleRemove = title;
			this.textRemove = text;
			this.isDialogRemove = true;
		},
		onCloseRemove() {
			this.isDialogRemove = false;
		},

		async onRemove() {
			if (this.flagRemove === "CheckOut") {
				this.onCheckInOut(2);
			} else if (this.activeDelete === "updateAvatar") {
				await this.onEditPassword({ logo: this.logoMod });
				this.isUpdateAvatar = false;
			}
			this.onCloseRemove();
		},

		onCheck(status) {
			if (status === 1) {
				this.onCheckInOut(1);
			} else {
				this.flagRemove = "CheckOut";
				const title = TITLE.END_WORK;
				const text = TEXT.END_WORK;
				this.onRemoveDialog({ title, text });
			}
		},

		async onCheckInOut(args) {
			await this.getUserСheck(args);
			this.onUpdateCalendar();
		},

		onSelect({ value }, key) {
			if (key === "dateListStart") {
				this[key] = value;
				this.onUpdateCalendar();
			}
		},
		onDate(value, key) {
			if (key === "month") {

				if (!this.dateListStart) {
					this.dateListStart = { date: null, name: null };
				}
				this.dateListStart.date = `${ value }-01`;
				this.onUpdateCalendar();

				this.month = value;
				this.monthMod = getFormatYmToLongTitle(value);
			} else {
				this[key] = value;
			}
		},

		async onUpdateCalendar() {
			this.isPreloader = true;

			const { dateListStart, id } = this.$data;
			const date = dateListStart && dateListStart.date ? dateListStart.date : null;

			if (!id || !date) {
				this.isPreloader = false;
				return;
			}

			const type = "date";
			await this.getUserUpdateCalendar({ id, date, type });

			this.isPreloader = false;
		},

		onAutocomplete({ value }, key) {
			this[key] = value && value.id ? value.id : value;
		},
		onEventIconBtn(args) {
			const { key, item } = args;

			if (key === "openEditTime") {
				this.isEditTime = true;
				this.activeItem = item;
			} else if (key === "comment" || key === "sick") {
				const { dateListStart, id } = this.$data;
				const date = dateListStart && dateListStart.date ? dateListStart.date : null;
				if (!id || !date) {
					return;
				}
				const employee_id = id;
				this.$emit("updateCalendarEventIconBtn", { key, item, employee_id, date });
			}
		},
		onCloseEditTime() {
			this.isEditTime = false;
		},
		async onSendEditTime(args) {
			this.isEditTime = false;
			const { date } = args;
			await this.getUserEditTime({ args, id: this.id, date });
			this.onUpdateCalendar();
		},
		onRequestVacation(args) {
			this.$emit("updateRequestVacation", args);
		},
		getPhoto(logo) {
			if (logo) {
				return getAppUrl + logo;
			}

			return "";
		},
		onSplitArray(arr, chunkSize) {
			const result = [];
			for (let i = 0; i < arr.length; i += chunkSize) {
				result.push(arr.slice(i, i + chunkSize));
			}
			return result;
		},
		getLocation() {
			return `${ this.office } / ${ this.location }`;
		},
		getTimeMoment(decimalTime) {
			if (decimalTime % 1 !== 0) {
				const hours = (Math.floor(decimalTime) > 9)
					? Math.floor(decimalTime)
					: moment().hours(Math.floor(decimalTime)).format("HH");

				const decimalMinutes = decimalTime - hours;
				const minutes = moment().minutes(Math.round(decimalMinutes * 60)).format("mm");

				return `${ hours }:${ minutes }`;
			}

			return decimalTime;
		},

		calculateTimeDifference(totalTime, timeToSubtract) {
			return getCalculateTimeDifference(totalTime, timeToSubtract);
		},

		toggleShow() {
			this.show = !this.show;
		},

		getUpdateAvatar() {
			const title = "Update Avatar";
			const text = "Are you sure you want to update your avatar?";
			this.activeDelete = "updateAvatar";

			this.onRemoveDialog({ title, text });
		},

		srcFileSet(args) {
			this.logoMod.name = args;
		},

		cropSuccess(imgDataUrl) {
			console.log("-------- crop success --------");
			this.imgDataUrl = imgDataUrl;

			this.logoMod.url = imgDataUrl;
			this.logoMod.value = imgDataUrl;

			this.isUpdateAvatar = true;
		},
		cropUploadSuccess(jsonData, field) {
			console.log("-------- upload success --------");
			console.log(jsonData);
			console.log("field: " + field);
		},
		cropUploadFail(status, field) {
			console.log("-------- upload fail --------");
			console.log(status);
			console.log("field: " + field);
		},

		onPhotoZoom(args) {
			this.linkPreviewDoc = args;
			this.fileName = args.split("/").pop();
		},
		clearLinkPreviewDoc() {
			this.linkPreviewDoc = null;
		},
		updateMonthInfo(month_info) {
			const {
				bonus,
				charge,
				salary,
				total,
				late,
				undetected,
			} = month_info;

			this.bonus = !isNaN(bonus) ? Number(bonus).toFixed(2) : null;
			this.charge = !isNaN(charge) ? Number(charge).toFixed(2) : null;
			this.salary = !isNaN(salary) ? Number(salary).toFixed(2) : null;
			this.total = !isNaN(total) ? Number(total).toFixed(2) : null;
			this.late = !isNaN(late) ? Number(late).toFixed(2) : null;
			this.undetected = !isNaN(undetected) ? Number(undetected).toFixed(2) : null;
		},
	},
	async mounted() {
		const id = this.$route.params.id;

		await this.getUserProfileInfo(id);

		if (this.userProfile_duties) {
			this.dutiesHTML = this.userProfile_duties;
		}

		if (this.userProfile_user) {
			const {
				balance,
				company_id,
				department,
				department_id,
				dispatch_id,
				division_id,
				email,
				id: userId,
				office,
				location,
				image,
				position,
				show_check_button,
				start_working_date,
				time_worked,
				type,
				scf,
				month,
			} = this.userProfile_user;

			this.balance = balance;
			this.company_id = company_id;
			this.department = department;
			this.department_id = department_id;
			this.dispatch_id = dispatch_id;
			this.division_id = division_id;
			this.email = email;
			this.id = userId;
			this.name = this.userProfile_user.name;
			this.office = office;
			this.location = location;
			this.image = image;
			this.position = position;
			this.show_check_button = show_check_button;
			this.start_working_date = start_working_date;
			this.time_worked = time_worked;
			this.type = type;
			this.scf = scf;
			this.isMonth = toMonthBool(month);
		}

		this.overtimeData = this.getTimeMoment(this.userProfile_overtime);
		this.allTime = this.userProfile_total_schedule_time;
		this.workTime = this.userProfile_total_work_time;
		this.allTimeMod = this.getTimeMoment(this.userProfile_total_schedule_time);
		this.workTimeMod = this.getTimeMoment(this.userProfile_total_work_time);
		this.timeLeft = this.calculateTimeDifference(this.allTime, this.workTime);
		this.month_calendarData = this.userProfile_month_calendar;

		this.dateList = Array.isArray(this.userProfile_month)
			? this.userProfile_month.slice().reverse()
			: [];

		let startItem = null;

		if (Array.isArray(this.userProfile_month) && this.userProfile_month.length > 0) {
			if (this.month_calendarData) {
				startItem = this.userProfile_month.find(
					item => item.date === this.month_calendarData
				) || this.userProfile_month[0];
			} else {
				startItem = this.userProfile_month[0];
			}
		}

		if (startItem) {
			const { date, name } = startItem;
			this.dateListStart = { date, name };
		} else {
			this.dateListStart = { date: null, name: null };
		}

		if (this.isMonth) {
			this.month = this.userProfile_month_calendar
				? this.userProfile_month_calendar.slice(0, -3)
				: null;
			if (this.month) {
				this.monthMod = getFormatYmToLongTitle(this.month);
			}
			this.dateListStart = { date: this.userProfile_month_calendar, name: this.monthMod };

		}

		this.weeks = this.onSplitArray(this.userProfile_calendar || [], 7);

		this.modName = `${ this.name } (${ this.dispatch_id })`;

		this.logoMod.url = getAppUrl + this.image;
		this.logoMod.value = getAppUrl + this.image;

		this.$emit("updateUser", this.userProfile_user);

		if (this.department_id === 1 || this.department_id === 3 || this.department_id === 4 || this.department_id === 5) {
			this.bonus = "0";
			this.charge = "0";
			this.salary = "0";
			this.total = "0";
			this.late = "0";
			this.undetected = "0";
		}

		if (this.userProfile_month_info && this.userProfile_month_info.length > 0) {
			this.updateMonthInfo(this.userProfile_month_info[0]);
		}
	},

	watch: {
		userProfile_calendar(val, oldVal) {
			if (val !== oldVal) {
				this.weeks = this.onSplitArray(val || [], 7);
			}
		},

		userProfile_overtime(val, oldVal) {
			if (val !== oldVal) {
				this.overtimeData = this.getTimeMoment(val);
			}
		},
		userProfile_total_schedule_time(val, oldVal) {
			if (val !== oldVal) {
				this.allTime = val;
				this.allTimeMod = this.getTimeMoment(val);
				this.timeLeft = this.calculateTimeDifference(this.allTime, this.workTime);
			}
		},
		userProfile_total_work_time(val, oldVal) {
			if (val !== oldVal) {
				this.workTime = val;
				this.workTimeMod = this.getTimeMoment(val);
				this.timeLeft = this.calculateTimeDifference(this.allTime, this.workTime);
			}
		},
		userProfile_month_info(val, oldVal) {
			if (val !== oldVal && val && val.length > 0) {
				this.updateMonthInfo(val[0]);
			}
		},
		"userProfile_user.month": {
			immediate: true,
			handler(v) {
				if (v === undefined || v === null) {
					this.isMonthLocal = null;
					return;
				}
				this.isMonthLocal = (v === true || v === 1 || v === "1" || v === "true");
			},
		},
	},
};
</script>

<style scoped lang="scss">
@import "UserTabHome";
</style>
<!--<style lang="scss">-->
<!--@import "UserTabHomeAll";-->
<!--</style>-->
